import React from 'react';

import Label from 'ui-library/bs/Label';

interface LabelWrapperProps {
  label: string | null;
}

function LabelWrapper(props: LabelWrapperProps): JSX.Element {
  return <Label style={{paddingLeft: '0px'}}>{props.label}</Label>;
}

export default LabelWrapper;
